"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _luckyWheelApi = require("@/api/luckyWheelApi");
var _customerOrderApi = require("@/api/customerOrderApi");
var _orderDetail = _interopRequireDefault(require("@/views/orderList/order/lists/orderDetail.vue"));
var _excluded = ["page", "limit"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 与后端 LuckyWheelCouponUseStatusEnum 保持一致。
var COUPON_USE_STATUS_OPTIONS = [{
  label: '已使用',
  value: 1
}, {
  label: '待使用',
  value: 2
}, {
  label: '已过期',
  value: 3
}];
var PRIZE_STATUS_TAG = {
  0: 'info',
  1: 'warning',
  2: 'success',
  3: 'warning',
  4: '',
  5: 'success',
  6: 'info'
};
var defaultQuery = function defaultQuery() {
  return {
    keyword: '',
    prizeType: '',
    result: '',
    customerId: '',
    prizeStatus: '',
    couponUseStatus: ''
  };
};
var mapEnumOptions = function mapEnumOptions(list) {
  return (Array.isArray(list) ? list : []).map(function (item) {
    return {
      label: item.value,
      value: item.code
    };
  }).filter(function (item) {
    return item.label != null && item.value != null;
  });
};
var _default = exports.default = {
  name: 'LuckyWheelRecord',
  components: {
    OrderDetail: _orderDetail.default
  },
  data: function data() {
    return {
      listLoading: false,
      customerLoading: false,
      query: defaultQuery(),
      customerOptions: [],
      tableData: [],
      total: 0,
      allTotal: null,
      filteredTotal: null,
      exportLoading: false,
      appliedFilters: {},
      couponUseStatusOptions: COUPON_USE_STATUS_OPTIONS,
      pageData: {
        page: 1,
        limit: 10
      },
      prizeTypeOptions: [],
      resultOptions: [],
      prizeStatusOptions: []
    };
  },
  created: function created() {
    this.loadFilterEnums();
    this.searchCustomerOptions('');
    this.fetchList();
  },
  methods: {
    hasRelatedOrder: function hasRelatedOrder(orderNo) {
      var value = orderNo == null ? '' : String(orderNo).trim();
      return value !== '' && value !== '—' && value !== '-';
    },
    openOrderDetail: function openOrderDetail(orderNo) {
      if (!this.hasRelatedOrder(orderNo)) return;
      this.$refs.OrderDetailRef.openDetail(String(orderNo).trim());
    },
    couponUseStatusText: function couponUseStatusText(row) {
      if (row.couponUseStatusDesc) return row.couponUseStatusDesc;
      if (row.couponUseStatus == null || row.couponUseStatus === '') return '—';
      var option = this.couponUseStatusOptions.find(function (item) {
        return item.value === Number(row.couponUseStatus);
      });
      return option ? option.label : '—';
    },
    fetchAllTotal: function () {
      var _fetchAllTotal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _luckyWheelApi.luckyWheelRecordExportCountApi)(_objectSpread({}, this.appliedFilters));
            case 1:
              data = _context.v;
              this.allTotal = data && data.allCount != null ? Number(data.allCount) : null;
              this.filteredTotal = data && data.filteredCount != null ? Number(data.filteredCount) : null;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.allTotal = null;
              this.filteredTotal = null;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchAllTotal() {
        return _fetchAllTotal.apply(this, arguments);
      }
      return fetchAllTotal;
    }(),
    onExportVisible: function onExportVisible(visible) {
      if (visible) this.fetchAllTotal();
    },
    handleExport: function () {
      var _handleExport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(command) {
        var data, link, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(this.exportLoading || this.listLoading || !['filtered', 'all'].includes(command))) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (!(command === 'filtered' && this.total === 0 || command === 'all' && this.allTotal === 0)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              this.exportLoading = true;
              _context2.p = 3;
              _context2.n = 4;
              return (0, _luckyWheelApi.luckyWheelRecordExportApi)(_objectSpread(_objectSpread({}, this.appliedFilters), {}, {
                exportAll: command === 'all'
              }));
            case 4:
              data = _context2.v;
              if (!(!data || !data.fileName)) {
                _context2.n = 5;
                break;
              }
              throw new Error('导出失败，未获取到文件地址');
            case 5:
              link = document.createElement('a');
              link.href = data.fileName;
              link.target = '_blank';
              link.rel = 'noopener';
              document.body.appendChild(link);
              link.click();
              link.remove();
              this.$message.success('导出成功');
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t2 = _context2.v;
              this.$message.error(_t2.message || '导出失败，请稍后重试');
            case 7:
              _context2.p = 7;
              this.exportLoading = false;
              return _context2.f(7);
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 6, 7, 8]]);
      }));
      function handleExport(_x) {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    prizeStatusTagType: function prizeStatusTagType(status) {
      var n = Number(status);
      return PRIZE_STATUS_TAG[n] != null ? PRIZE_STATUS_TAG[n] : 'info';
    },
    prizeContentLines: function prizeContentLines(row) {
      var text = row && row.prizeContent != null ? String(row.prizeContent).trim() : '';
      if (!text) return ['—'];
      return text.split(/\n/).filter(function (line) {
        return line !== '';
      });
    },
    loadFilterEnums: function () {
      var _loadFilterEnums = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$Promise$all, _yield$Promise$all2, prizeTypes, results, prizeStatuses, couponStatuses;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return Promise.all([(0, _luckyWheelApi.luckyWheelPrizeTypeListApi)().catch(function () {
                return [];
              }), (0, _luckyWheelApi.luckyWheelRecordResultListApi)().catch(function () {
                return [];
              }), (0, _luckyWheelApi.luckyWheelRecordPrizeStatusListApi)().catch(function () {
                return [];
              }), (0, _luckyWheelApi.luckyWheelCouponUseStatusListApi)().catch(function () {
                return [];
              })]);
            case 1:
              _yield$Promise$all = _context3.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
              prizeTypes = _yield$Promise$all2[0];
              results = _yield$Promise$all2[1];
              prizeStatuses = _yield$Promise$all2[2];
              couponStatuses = _yield$Promise$all2[3];
              this.prizeTypeOptions = mapEnumOptions(prizeTypes);
              this.resultOptions = mapEnumOptions(results);
              this.prizeStatusOptions = mapEnumOptions(prizeStatuses);
              this.couponUseStatusOptions = mapEnumOptions(couponStatuses).length ? mapEnumOptions(couponStatuses) : COUPON_USE_STATUS_OPTIONS;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadFilterEnums() {
        return _loadFilterEnums.apply(this, arguments);
      }
      return loadFilterEnums;
    }(),
    searchCustomerOptions: function () {
      var _searchCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(keyword) {
        var res, list, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.customerLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return (0, _customerOrderApi.companyappAutoListApi)({
                keyword: keyword || ''
              });
            case 2:
              res = _context4.v;
              list = Array.isArray(res) ? res : [];
              this.customerOptions = list.map(function (item) {
                var customerId = item.customerId != null ? Number(item.customerId) : Number(item.id);
                if (!Number.isInteger(customerId) || customerId <= 0) return null;
                return {
                  customerId: customerId,
                  appName: item.appName || item.customerName || item.name || String(customerId)
                };
              }).filter(Boolean);
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              this.customerOptions = [];
            case 4:
              _context4.p = 4;
              this.customerLoading = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function searchCustomerOptions(_x2) {
        return _searchCustomerOptions.apply(this, arguments);
      }
      return searchCustomerOptions;
    }(),
    buildListParams: function buildListParams() {
      var params = {
        page: this.pageData.page,
        limit: this.pageData.limit
      };
      var kw = (this.query.keyword || '').trim();
      if (kw) params.keyword = kw;
      if (this.query.prizeType !== '' && this.query.prizeType != null) params.prizeType = Number(this.query.prizeType);
      if (this.query.result !== '' && this.query.result != null) params.result = Number(this.query.result);
      if (this.query.customerId !== '' && this.query.customerId != null) params.customerId = Number(this.query.customerId);
      if (this.query.prizeStatus !== '' && this.query.prizeStatus != null) params.prizeStatus = Number(this.query.prizeStatus);
      if (this.query.couponUseStatus !== '' && this.query.couponUseStatus != null) params.couponUseStatus = Number(this.query.couponUseStatus);
      return params;
    },
    fetchList: function () {
      var _fetchList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this$buildListParams, page, limit, filters, data, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              this.listLoading = true;
              _context5.p = 1;
              _this$buildListParams = this.buildListParams(), page = _this$buildListParams.page, limit = _this$buildListParams.limit, filters = _objectWithoutProperties(_this$buildListParams, _excluded);
              _context5.n = 2;
              return (0, _luckyWheelApi.luckyWheelRecordPageApi)(_objectSpread({
                page: page,
                limit: limit
              }, filters));
            case 2:
              data = _context5.v;
              this.tableData = data && data.list || [];
              this.total = data && data.total != null ? Number(data.total) : 0;
              this.appliedFilters = filters;
              this.filteredTotal = null;
              this.fetchAllTotal();
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              this.tableData = [];
              this.total = 0;
            case 4:
              _context5.p = 4;
              this.listLoading = false;
              return _context5.f(4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function fetchList() {
        return _fetchList.apply(this, arguments);
      }
      return fetchList;
    }(),
    handleSearch: function handleSearch() {
      this.pageData.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.query = defaultQuery();
      this.pageData.page = 1;
      this.searchCustomerOptions('');
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.pageData.page = page;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.pageData.limit = limit;
      this.pageData.page = 1;
      this.fetchList();
    }
  }
};